import React from "react";
import Box from "@material-ui/core/Box";

export default function SearchBar({ children, ...props }) {
  return (
    <Box
      width={{ xs: "100%", md: 412 }}
      p={2}
      position="absolute"
      top={0}
      left={0}
      zIndex={{ xs: 40, md: 41 }}
      display="flex"
      {...props}
    >
      <Box
        boxShadow={1}
        borderRadius={10}
        bgcolor="white"
        display="flex"
        alignItems="center"
        flexGrow={1}
        maxWidth="100%"
      >
        {children}
      </Box>
    </Box>
  );
}
